import React from 'react';
import { Button } from '../ui/Button';
import { Check, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-[#F5F2EA] pt-12 pb-20 md:pt-20 md:pb-24 overflow-hidden" data-id="element-147">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#4A6741]/5 -skew-x-12 translate-x-1/4 hidden lg:block" data-id="element-148" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-149">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-150">
          {/* Copy Column */}
          <div className="flex-1 max-w-2xl text-center lg:text-left" data-id="element-151">
            <div className="inline-flex items-center gap-2 bg-[#4A6741]/10 text-[#4A6741] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-152">
              <Star className="w-4 h-4 fill-current" data-id="element-153" />
              <span data-id="element-154">Método Natural Care</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-[1.1] mb-6 tracking-tight" data-id="element-155">
              Cosmética Natural y{' '}
              <span className="text-[#4A6741]" data-id="element-156">Artesanal en Casa</span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-157">
              Aprende paso a paso a elaborar tus propios productos de cuidado
              personal con calidad profesional, ingredientes seguros y sin miedo
              a fallar.
            </p>

            <div className="space-y-3 mb-10 text-left max-w-md mx-auto lg:mx-0" data-id="element-158">
              {['Fórmulas exactas y estables (sin separaciones)', 'Control total de ingredientes y seguridad', 'Ahorra dinero y cuida tu piel de verdad'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-159">
                  <div className="mt-1 bg-[#4A6741] rounded-full p-0.5 flex-shrink-0" data-id="element-160">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-161" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-162">{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-163">
              <div className="flex flex-col items-center" data-id="element-164">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-165">
                  <span className="text-gray-400 line-through text-lg" data-id="element-166">
                    $27.00
                  </span>
                  <span className="text-3xl font-bold text-[#C06C54]" data-id="element-167">
                    $6.36 USD
                  </span>
                </div>
                <Button variant="urgent" size="xl" withMicrocopy data-id="element-168">
                  SÍ, QUIERO EL EBOOK POR $6,36 USD
                </Button>
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-169">
            <div className="relative" data-id="element-170">
              <div className="absolute inset-0 bg-[#4A6741] rounded-3xl rotate-3 opacity-20 blur-xl scale-95 transform translate-y-4" data-id="element-171" />
              <img src="https://cdn.magicpatterns.com/uploads/34JWmqSSYCqR66UCzDvY7p/mockup1.png" alt="Cosmética Natural y Artesanal en Casa eBook Mockup" className="relative w-full h-auto rounded-2xl shadow-2xl transform transition-transform hover:scale-[1.01] duration-500" data-id="element-172" />

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 md:bottom-10 md:-right-10 bg-white p-4 rounded-xl shadow-xl border border-gray-100 max-w-[200px] hidden md:block" data-id="element-173">
                <div className="flex items-center gap-1 mb-1" data-id="element-174">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-175" />)}
                </div>
                <p className="text-xs text-gray-600 font-medium" data-id="element-176">
                  "Por fin mis cremas no se separan. ¡Gracias!"
                </p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-177">- Laura M.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}